import type { SliderValueLabelProps } from '@mui/material'
import Tooltip, { type TooltipProps } from '@mui/material/Tooltip'
import { styled } from '@mui/material/styles'

const ToBeStyledTooltip = ({ className, ...props }: TooltipProps) => (
	<Tooltip {...props} classes={{ tooltip: className }} />
)

const TextOnlyTooltip = styled(ToBeStyledTooltip)(({ theme }) => ({
	// @ts-ignore theme.palette type
	color: theme.palette.colors.selectedTheme.text.value,
	// @ts-ignore theme.palette type
	backgroundColor: theme.palette.colors.selectedTheme.slider.tooltip.background,
	marginTop: '1px !important',
	fontSize: '13px',
}))

export default function ValueLabel(props: SliderValueLabelProps) {
	const { children, open, value } = props

	return (
		<TextOnlyTooltip
			open={open}
			enterTouchDelay={0}
			disableInteractive
			placement="top"
			title={value}
			arrow
		>
			{children}
		</TextOnlyTooltip>
	)
}
